import styles from "./pricing.module.css";

export default function CreditBadge({ credits }) {
  return (
    <span
      className={`${styles.creditBadge} ${styles["creditLevel" + credits]}`}
    >
      {credits}C
    </span>
  );
}
